'use strict';

export const path = 'renderings/'